(ns teamoesterreich.admin-mode.administration.rights.rights-table
  (:require ["react-virtualized" :as rv]
            [clojure.string :as string]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.view-state :as v-state]
            [goog.date.DateTime]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            [teamoesterreich.admin-mode.component.org-selector :as org-selector]
            [teamoesterreich.admin-mode.data.organisation :as d-organisation]
            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure]
            [reagent.core :as r]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
            [teamoesterreich.admin-mode.static-data :as staticData]))


(defonce RIGHTS_LIST d-rights/RIGHTS_LIST)


(defn right-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [:span
       (or (:name (get (into {} RIGHTS_LIST) cell-data)) cell-data)])))

(defn edit-cell-renderer [!st]
  (fn [js-parm]
    (let [{cell-data "cellData"} (js->clj js-parm)]
      (r/as-element
        [mui/icon-button {:label   "bearbeiten"
                          :onClick #(a/open-user-view cell-data 9)
                          } [edit {:fontSize "small"}]]))))

(defn drop-cell-renderer [!st]
  (fn [js-parm]
    (let [{row-data "rowData"} (js->clj js-parm)
          r-orgId (d-rights/mask-to-reg (str (get-in row-data ["right-organisationMask"])))]
      (if (d-rights/allow-admin-for RIGHTS_LIST r-orgId)
        (r/as-element
          [mui/icon-button {:label   "löschen"
                            :onClick #(swap! !st assoc :delete-right row-data)
                            } [delete-forever {:fontSize "small"}]])
        (r/as-element [:div "-"])))))



(defn inside-table [!st rows]

  (fn [m]
    (let [width (aget m "width")
          height (aget m "height")
          !sort (r/cursor !st [:sort])
          !reverse (r/cursor !st [:reverse])
          ]
      (r/as-element
        [:> rv/Table
         {:headerHeight    50
          :height          (- height 70)
          :rowCount        (count rows)
          :rowGetter       (fn [i]
                             ;(println (str "rowGet " (aget i "index")))
                             (clj->js (nth rows (aget i "index"))))
          :rowClassName    (fn [i] (when (odd? (aget i "index")) "table-odd"))
          :sort            (fn [s] (swap! !st assoc :sort (aget s "sortBy") :reverse (= "DESC" (aget s "sortDirection")) :invalidated true))
          :sortBy          @!sort
          :sortDirection   (if @!reverse "DESC" "ASC")
          :rowHeight       45
          :width           width
          :headerClassName "headerColumn"
          :className       "RightsList"}
         (log/debug "rerender " m (clj->js rows))


         [:> rv/Column
          {:label     "TomId"
           :dataKey   (name :user-tomId)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden"}
           :width     120}]
         [:> rv/Column
          {:label     "Vorname"
           :dataKey   (name :user-firstName)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden" :textAlign "left"}
           :width     200}]
         [:> rv/Column
          {:label     "Nachname"
           :dataKey   (name :user-lastName)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden" :textAlign "left"}
           :width     220}]
         [:> rv/Column
          {:label        "Rolle"
           :dataKey      (name :right)
           :className    "bordered exampleColumn"
           :style        #js {:overflow "hidden" :textAlign "left"}
           :cellRenderer right-renderer
           :width        220}]
         [:> rv/Column
          {:label     (txt/txt :rights-level 1)
           :dataKey   (name :organisationMain)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden" :textAlign "left"}
           :width     190}]
         [:> rv/Column
          {:label     (txt/txt :rights-level 2)
           :dataKey   (name :organisationDepartment)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden" :textAlign "left"}
           :width     190}]
         [:> rv/Column
          {:label     (txt/txt :rights-level 3)
           :dataKey   (name :organisation)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden" :textAlign "left"}
           :width     220}]
         [:> rv/Column
          {:label        "#"
           :dataKey      (name :user-tomId)
           :className    "bordered exampleColumn"
           :cellRenderer (edit-cell-renderer !st)
           :width        70}]
         (when (d-rights/allow-admin-for d-rights/RIGHTS_LIST)
           [:> rv/Column
            {:label        "#"
             :dataKey      (name :right-uuid)
             :className    "bordered exampleColumn"
             :cellRenderer (drop-cell-renderer !st)
             :width        70}])

         ]))))


(defn right-filter [!waiting? !search !filter !invalidated]
  [mui/grid
   {:container  true
    :direction  "row"
    :alignItems "flex-start"
    :justify    "flex-start"
    :spacing    1
    :style      {:padding "5px"}}

   [mui/grid
    {:item true
     :md   2
     :xs   6
     }
    [mui/text-field
     {:default-value   (str @!search)
      :label           "Suche"
      :fullWidth       true
      :placeholder     "Suche in Liste ..."
      :InputLabelProps {:disableAnimation true :shrink true}
      :style           {:display "inline-block"}
      :onChange        (h/wait-do !waiting? (fn [e] (reset! !search e) (reset! !invalidated true)))
      :multiline       false}]
    ]

   [mui/grid
    {:item true
     :md   2
     :xs   6
     }

    [mui/form-control
     {
      :fullWidth true
      }
     [mui/input-label "Rolle "]
     [mui/select
      {:multiple false
       :value    (or (get-in @!filter [:right]) "")
       :onChange (fn [e]
                   (swap! !filter assoc :right (h/event-value e))
                   (reset! !invalidated true))
       }
      [mui/menu-item {:value ".*"} "Alle"]
      (let []
        (for [[k v] (d-rights/get-my-admin-rights (or (get-in @!filter [:organisation]) (get-in @!filter [:organisationDepartment]) ".*"))]
          ^{:key (str "RIGHTS_LIST-" k)} [mui/menu-item {:style {} :value k} (:name v)]))
      ]]]

   [mui/grid
    {:item true
     :md   8
     :xs   12
     }
    [org-selector/get-selector !filter (fn [] (reset! !invalidated true)) (d-rights/get-rights-orgId-filter d-rights/ADMIN)]

    ]

   ])


(defn enrich-data-fn [entry dep-list dst-list]
  ;(log/debug "enrich-data-fn " (clj->js entry) (count dep-list) (count dst-list))
  (let [mask (str (:right-organisationMask entry))
        section (:right-section entry)]
    (merge entry
           [:user-tomId (get-in entry [:right-admin :user-tomId])]
           [:user-firstName (get-in entry [:right-admin :user-firstName])]
           [:user-lastName (get-in entry [:right-admin :user-lastName])]
           [:right (or (:name (get RIGHTS_LIST section)) section)]
           [:right-section section]
           [:organisationDepartment (d-organisation/get-department-for-key mask dep-list)]
           [:organisation (reduce (fn [c [k n]] (if (= k mask) n c)) "-" dst-list)]
           )))

(defn filter-fn [data !st]
  (log/debug "filter-fn data:" (clj->js data) " st:" (clj->js @!st))
  (let [search_ (:search @!st)
        filter_ (:filter @!st)]
    (filter (fn [[k e]] (and
                          (not (false? (:right-active e)))
                          ;search
                          (re-find
                            (re-pattern (reduce (fn [c e] (str c "(?=.*" e ")")) "(?i)^" (clojure.string/split search_ " ")))
                            (str (:user-tomId e) "#" (:user-firstName e) "#" (:user-lastName e)))

                          ;rights
                          (re-find
                            (re-pattern (reduce (fn [c e] (str c "(?=.*" e ")")) "(?i)^" [(or (:right filter_) ".*")]))
                            (str (:right-section e)))
                          ;
                          ;;:organisationMain
                          ;(cond
                          ;  (= "0" (:filter-organizationMain filter_)) (= ".*" (:filter-organizationMain e))
                          ;  :else (let [pattern (str (reduce (fn [c e] (str c "|" e "")) "(?=####" (or (:filter-organizationMain filter_) [".*"])) ")")]
                          ;          (re-matches (re-pattern pattern) (str (:right-organisationMask e)))))

                          ;:organisationDepartment
                          ;(cond
                          ;  (= "0" (:filter-organizationDepartment filter_)) (= ".*" (:right-organisationMask e))
                          ;  :else (let [pattern (str (reduce (fn [c e] (str c "|" e "")) "(?=####" (or (:filter-organizationDepartment filter_) [".*"])) ")")]
                          ;          (re-matches (re-pattern pattern) (str (:right-organisationMask e)))))
                          ;
                          ;;org
                          ;(let [pattern (str (reduce (fn [c e] (str c "|" e "")) "####" (or (:filter-organization filter_) [".*"])))]
                          ;  (js/console.log "do  " (str (:right-organisationMask e)) pattern "--- " (re-matches (re-pattern pattern) (str (:right-organisationMask e))))
                          ;  (re-matches (re-pattern pattern) (str (:right-organisationMask e))))
                          (org-selector/check-org-id (str (:right-organisationMask e)) filter_)

                          ))
            data)))

(defn update-list [!st dep-list dst-list]
  (h/update-table-list !st d-rights/<get-all {:filter-fn filter-fn :default-sort :user-tomId :data-walk-fn (fn [entry] (enrich-data-fn entry dep-list dst-list))}))



(defn get-table [!st !rows]
  (fn [] [:> rv/AutoSizer
          {:style {:height "100%" :minHeight "400px"}
           :sort  (str "rerender !st" @!st)}
          (inside-table !st @!rows)]))


(defn get-it []
  (js/console.log "Mount rights list")
  (let [!st (r/atom {:invalidated true :data {} :rows [] :search nil :filter {:organisation ".*" :right ".*"}} :sort nil :reverse false)
        !loaded? (r/cursor !st [:loaded])
        !invalidated (r/cursor !st [:invalidated])
        !delete-right (r/cursor !st [:delete-right])
        !filter (r/cursor !st [:filter])
        !search (r/cursor !st [:search])
        !rows (r/cursor !st [:rows])
        !waiting? (r/cursor !st [:waiting])

        !organisations (r/cursor v-state/app-state [:organisations])
        dep-mask-list (or (d-organisation/get-lv-filter-list @!organisations) [])
        dst-mask-list (or (d-organisation/get-dest-list @!organisations) [])

        ]
    (fn []
      (update-list !st dep-mask-list dst-mask-list)
      (if-not @!loaded?
        (do [:div {:style {:marginTop "100px"}} [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}] "  loading..."])

        [mui/paper

         [mui/grid
          {:container  true
           :direction  "row"
           :alignItems "stretch"
           :justify    "flex-start"
           :spacing    1
           :style      {:marginTop "15px" :height "calc(100% - 70px)" :minHeight "400px"}
           }

          [mui/grid
           {:item true
            :lg   8
            :md   6
            :xs   6
            :type {:textAlign "bottom"}
            }
           [mui/typography {:variant "h5" :padding "5px 0 0 0"
                            :onClick #(swap! !st assoc :invalidated true :loaded false)
                            } " Rechte Liste "]
           ]


          [mui/grid
           {:item true
            :xs   10
            }
           [right-filter !waiting? !search !filter !invalidated]

           ]
          [mui/grid
           {:item true
            :lg   2
            :md   3
            :xs   1
            }
           [ws-event-sync-component/ws-event-reload !loaded? :warning]
           ]
          [mui/grid
           {:item  true
            :xs    12
            :style {:height "calc(100% - 50px)"}
            }
           [are-you-sure/are-you-sure-modal !delete-right
            [:p "Bist du sicher, dass du dieses Recht:"
             [:br]
             [:br]
             [:span {:style {:color "darkblue"}} (get @!delete-right "user-tomId") ") " (get @!delete-right "user-firstName") " " (get @!delete-right "user-lastName")]
             [:br]
             [:span {:style {:color "darkblue"}}
              (or (:name (get (into {} RIGHTS_LIST) (get @!delete-right "right-section"))) (get @!delete-right "right-section"))
              ]
             [:br]
             [:span {:style {:color "darkblue"}}
              (get @!delete-right "organisationDepartment") " / " (get @!delete-right "organisation")
              ]
             [:br]
             ;@!delete-right
             [:br]
             "löschen möchtest?"]
            "Löschen"
            (fn []
              (d-rights/>edit-right (get @!delete-right "right-uuid") {:right-active false}
                                    #(reset! !loaded? false)))
            ]
           [get-table !st !rows]
           ]
          [mui/grid
           {:item  true
            :xs    12
            :style {:height "calc(100% - 50px)"}
            }

           [mui/button {:style    {:verticalAlign "center" :margin "0px 0 7px 10px"}
                        :variant "outlined"
                        :onClick  #(d-rights/csv-list)
                        } "CSV"]
           [mui/button {:style    {:verticalAlign "center" :margin "0px 0 7px 10px"}
                        :variant "outlined"
                        :onClick  #(d-rights/agr-csv-list)
                        } "CSV Gruppiert"]
           ]
          ]

         ])))
  )



